// src/data/dealLinks.js - Contains all deal links for products

export const dealLinks = {
  screen: {
    default: "https://alextimm.com/deals/screens",
    "echomap-73sv-uhd2": "https://at.fish/EchomapUHD2-73sv",
    "echomap-93sv-uhd2": "https://at.fish/EchomapUHD2-93sv",
    // Add more screen-specific links
  },
  livescope: {
    default: "https://at.fish/LivescopePlusSystem",
    "livescope-plus-lvs34": "/products/livescope-plus-lvs34",
    // Add more livescope links
  },
  openWater: {
    default: "https://alextimm.com/deals/openwater",
    // Add specific open water transducer links
  },
  iceFishing: {
    default: "https://alextimm.com/deals/icefishing",
    // Add specific ice fishing transducer links
  },
  battery: {
    default: "https://ampedoutdoors.com",
    "amped-30ah-lifepo4": "https://at.fish/Amped30Ah",
    "amped-32ah-nmc": "https://ampedoutdoors.com",
    // Add more battery links
  },
  shuttle: {
    default: "https://alextimm.com/deals/shuttles",
    // Add specific shuttle links
  },
  pole: {
    default: "https://alextimm.com/deals/poles",
    // Add specific pole links
  }
};

// Helper function to get deal link by product ID
export const getDealLinkById = (productType, productId) => {
  if (productId && dealLinks[productType][productId]) {
    return dealLinks[productType][productId];
  }
  return dealLinks[productType].default;
};

// Helper function to get deal link by product name (for backward compatibility)
export const getDealLinkByName = (productType, productName) => {
  if (!productName) return dealLinks[productType].default;
  
  // Convert name to ID format (lowercase, spaces to dashes)
  const formattedName = productName.toLowerCase().replace(/\s+/g, '-');
  
  // Check if we have a link for this formatted name
  if (dealLinks[productType][formattedName]) {
    return dealLinks[productType][formattedName];
  }
  
  // Check for exact match
  if (dealLinks[productType][productName]) {
    return dealLinks[productType][productName];
  }
  
  // Check for lowercase match
  const lowerCaseName = productName.toLowerCase();
  if (dealLinks[productType][lowerCaseName]) {
    return dealLinks[productType][lowerCaseName];
  }
  
  // Return default link
  return dealLinks[productType].default;
}; 